<template>
  <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-xs-12">
    <q-card class="shadow-3" square>
      <q-card-section class="flexbox">
        <div class="package-item">
          <div class="package-img">
            <img
              :src="require(`../assets/${package.name.toLowerCase()}.svg`)"
              alt
            />
          </div>
          <div class="package-title text-grey-7">{{ package.name }}</div>
          <div class="package-price">
            <div class="text-primary">
              ${{
                payment === "Yearly" ? package.annual_fee : package.monthly_fee
              }}
            </div>
            <div>/ {{ payment }}</div>
          </div>
          <div class="package-description">{{ package.description }}</div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
export default {
  props: {
    package: Object,
    index: Number,
  },
  computed: {
    payment() {
      return this.$store.state.pack.payment;
    },
  },
};
</script>
